import { OrderInjectionLog } from "./orders.service.types";

export const orderInjectionLogAdapter = (
  orderInjections: OrderInjectionLog[]
) => {
  return orderInjections.map(orderInjection => {
    const { responseBody } = orderInjection;
    return responseBody;
  });
};
